import React, {createContext, PropsWithChildren, useContext, useMemo} from 'react';

import {useAppSelector} from '../../../helpers/appReduxHelpers';
import {P2LayoutsEnum} from '../../../models/api/preferencesModel';
import {getP2Layout} from '../../../store/data/preferences/preferencesSelectors';

/*
 * Types.
 */

export interface CompactP2ContextValue {
  isCompact: boolean;
}

interface CompactP2ProviderProps {
  /** Useful for testing, storybook */
  isCompactOverride?: boolean;
}

/*
 * Context.
 */

const CompactP2Context = createContext<CompactP2ContextValue>({
  isCompact: false,
});

/*
 * Provider.
 */

export const CompactP2Provider = (props: PropsWithChildren<CompactP2ProviderProps>) => {
  const preference = useAppSelector(getP2Layout);
  const finalIsCompact = props.isCompactOverride ?? preference === P2LayoutsEnum.COMPACT;

  const value = useMemo(() => ({isCompact: finalIsCompact}), [finalIsCompact]);

  return <CompactP2Context.Provider value={value}>{props.children}</CompactP2Context.Provider>;
};

/*
 * Hook.
 */

export function useCompactP2Context() {
  return useContext(CompactP2Context);
}
